import { render, staticRenderFns } from "./LandingQrInfo.vue?vue&type=template&id=ebd873b2&scoped=true&"
import script from "./LandingQrInfo.vue?vue&type=script&lang=js&"
export * from "./LandingQrInfo.vue?vue&type=script&lang=js&"
import style0 from "./LandingQrInfo.vue?vue&type=style&index=0&id=ebd873b2&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ebd873b2",
  null
  
)

/* custom blocks */
import block0 from "./LandingQrInfo.vue?vue&type=custom&index=0&blockType=i18n&locale=en&lang=yaml"
if (typeof block0 === 'function') block0(component)
import block1 from "./LandingQrInfo.vue?vue&type=custom&index=1&blockType=i18n&locale=ru&lang=yaml"
if (typeof block1 === 'function') block1(component)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCol } from 'vuetify/lib/components/VGrid';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VCol,VContainer,VRow})
